<template>
	<div class="container-fluid">
		<div class="row">
			<div class="col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4">
				<div class="card">
					<div class="card-header bg-info text-white">
						<div class="row">
							<div class="col text-left">
								<span class="fa fa-users mr-2"></span>
								Listado de grupos
							</div>
							<div class="col text-right">
								<button class="btn btn-sm btn-warning" @click="nuevo()">
									<span class="fa fa-plus mr-2"></span>
									Nuevo
								</button>
							</div>
						</div>
					</div>
					<div class="table-responsive">
						<table class="table table-striped m-0">
							<tbody>
								<tr v-for="grupo in listadoGrupos" :key="grupo.ID_grupo">
									<td style="width:40px;text-align:center;">
										<span class="fa fa-users"></span>
									</td>
									<td @click="getGrupo(grupo.ID_grupo)" style="cursor:pointer;">{{grupo.nombre}}</td>
									<td style="width:40px;text-align:center;">
										<button class="btn btn-sm btn-danger" @click="eliminar(grupo.ID_grupo)">
											<span class="fa fa-trash"></span>
										</button>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
			<div class="col-xs-12 col-sm-12 col-md-6 col-lg-8 col-xl-8" v-if="grupo">
				<div class="card">
					<div class="card-header bg-warning">
						<div class="row">
							<div class="col text-left">
								Detalles del grupo
							</div>
							<div class="col text-right">
								<button class="btn btn-sm btn-dark" @click="guardar()">
									<span class="fa fa-save mr-2"></span>
									Guardar
								</button>
							</div>
						</div>
					</div>
					<div class="card-body">
						<div class="form-group">
							<label for="">Nombre del grupo</label>
							<input type="text" class="form-control" placeholder="Nombre del grupo" v-model="grupo.nombre">
						</div>
						<hr>
						<div class="form-group">
							<label for="">Descripción</label>
							<textarea rows="5" class="form-control" placeholder="Puedes añadir una descripción de este grupo" v-model="grupo.descripcion"></textarea>
						</div>
					</div>
					<div class="card-body bg-light">
						<h5><b>Miembros del grupo</b></h5>
						<input-query placeholder="Busca un usuario para añadirlo" url="gestion-grupos/php/busca-usuarios.php" @selected="addUsuario($event)" :realtime="true" input-class="form-control"></input-query>
					</div>
					<div class="table-responsive">
						<table class="table table-striped table-condensed m-0">
							<tbody>
								<tr v-for="(usuario, index) in grupo.usuarios" :key="usuario.ID_usuario">
									<td style="width:40px;text-align:center;">
										<span class="fa fa-user"></span>
									</td>
									<td>
										{{usuario.nombre}} {{usuario.apellidos}}
									</td>
									<td style="width:40px;text-align:center;">
										<button class="btn btn-sm btn-danger" @click="grupo.usuarios.splice(index, 1)">
											<span class="fa fa-trash"></span>
										</button>
									</td>
								</tr>
							</tbody>
							<tbody v-if="grupo.usuarios.length === 0">
								<tr class="bg-danger text-white">
									<td style="text-align:center" class="p-3">
										<span class="fa fa-info" style="font-size:3em;"></span>
										<h5><b>Este grupo no tiene miembros</b></h5>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import API from './api'

export default {
	data () {
		return {
			listadoGrupos: [],
			grupo: null
		}
	},

	created () {
		this.getListado()
	},

	methods: {
		getListado () {
			API.getListado()
				.then(res => {
					this.listadoGrupos = res.data.listado
				})
				.catch(e => {
					this.$store.commit('alertas/error', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},
		getGrupo (idGrupo) {
			API.getGrupo(idGrupo)
				.then(res => {
					this.grupo = res.data.grupo
				})
				.catch(e => {
					this.$store.commit('alertas/error', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},

		nuevo () {
			this.grupo = {
				ID_grupo: null,
				nombre: '',
				descripcion: '',
				usuarios: []
			}
		},

		addUsuario (ev) {
			for (let i = 0; i < this.grupo.usuarios.length; i++) {
				if (this.grupo.usuarios[i].ID === ev.datos.ID) {
					return
				}
			}

			this.grupo.usuarios.push(ev.datos)
		},
		guardar () {
			API.setGrupo(this.grupo)
				.then(res => {
					this.grupo = res.data.grupo
					this.getListado()
					this.$store.commit('alertas/alert', {
						titulo: 'Guardado',
						mensaje: 'Se han guardado los cambios correctamente'
					})
				})
				.catch(e => {
					this.$store.commit('alertas/error', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},
		eliminar (idGrupo) {
			this.$store.commit('alertas/confirm', {
				titulo: 'Eliminar grupo',
				mensaje: '¿Estás seguro de que quieres eliminar este grupo?',
				callback: (acepta) => {
					if (acepta) {
						API.delGrupo(idGrupo)
							.then(res => {
								this.grupo = null
								this.getListado()
							})
							.catch(e => {
								this.$store.commit('alertas/error', {
									titulo: 'Error',
									mensaje: e.response.data.error
								})
							})
					}
				}
			})
		}
	}
}
</script>




// WEBPACK FOOTER //
// src/modulos/gestion-grupos/vue/app.vue